import StringsBase from 'localization/StringsBase';

export default class StringsUK extends StringsBase{
    static get Disclaimer() {return Disclaimer;}
    static get Welcome() {return Welcome;}
    static get StatModelMoreInfo() {return StatModelMoreInfo;}
    static get MoreInfo() {return MoreInfo;}
    static get General() {return General;}
    static get Loss() {return Loss;}
    static get Age() {return Age;}
    static get Sound() {return Sound;}
    static get Telephone() {return Telephone;}
    static get Quiet() {return Quiet;}
    static get Effort() {return Effort;}
    static get Summary() {return Summary;}
    static get Searching() {return Searching;}
    static get Results() {return Results;}
    static get MarketingPanel() {return MarketingPanel;}
}

const General = {  
    Logout: "Sign out",
    Next: "Next",
};

const Disclaimer = {  
    Disclaimer: "By pressing Start, You acknowledge that (i) the Services do not provide a diagnosis or other recommendation for treatment or form a healthcare professional relationship between us and any Patient; and (ii) You are solely responsible for interpretation of any information, materials, results or data made available through the Services, the assessment of a Patient’s or potential Patient’s need for our products, Services, or other health care services, and the provision of any related medical advice to such Patient;",
};

const Welcome = {  
    WelcomeTitle: "Welcome",
    ToolTitle: "Referral Support Tool",
    DescriptionLine1: "<span class='smoke100'>This tool is intended to be</span> </br><span class='smoke180'>used by a hearing clinician with your patient present to support a </br> conversation about cochlear implants.</span>",
    DescriptionLine2: "<span class='smoke100'>It will</span> <span class='smoke180'>take about 1 minute</span> <span class='smoke100'>to answer 6 questions and </br>approximately 3-5 minutes to have a conversation about</br>the information displayed.</span>",
    StartButton: "Start",
    MoreInfoButton: "Find out more",
};

const StatModelMoreInfo = {  
    Title: "About Referral Support Tool",
};

const Age = {  
    Title: "Hearing profile",
    Description: "Choose an age group similar to your patient.",
    ButtonSmallerThan50: "<50",
    Button50To60: "50-60",
    Button60To70: "60-70",
    Button70To80: "70-80",
    Button80Plus: "80+",
};

const Loss = {  
    Title: "Hearing profile",
    Description: "Choose a degree of hearing loss similar to your patient.",
    ExtraDescription: "Ear under consideration",
    SeverePlain: null,//"Severe (60-80 dBHL)", // removed in the UK version
    SevereToProfoundPlain: "80-90 dBHL", // changed in the UK version
    ProfoundPlain: "90-100 dBHL", // changed in the UK version
    VeryProfoundPlain: "100+ dBHL", // changed in the UK version
    Severe: null, //"60-80 dBHL", // removed in the UK version
    SevereToProfound: "80-90 dBHL", // changed in the UK version
    Profound: "90-100 dBHL", // changed in the UK version
    VeryProfound: "100+ dBHL", // changed in the UK version

    PureToneAverage: "Pure tone average:",
    AidedCncScore: "Estimated aided word score range:",
    BinauralEstimatedRange: "Estimated binaural aided word score range:",
    PTAModerate: "40dBHL to 60dBHL",
    PTASevere: "60dBHL to 80dBHL",
    PTASevereToProfound: "80dBHL to 90dBHL",
    PTAProfound: "90dBHL to 100dBHL",
    PTAVeryProfound: "Over 100dBHL",
    ACSModerate: "9% to 69%",
    ACSSevere: "9% to 44%",
    ACSSevereToProfound: "8% to 36%",
    ACSProfound: "0% to 26%",
    ACSVeryProfound: "0% to 12%",
    BEASever: "23% to 55%",
    BEASevereToProfound: "22% to 48%",
    BEAProfound: "15% to 39%",
    BEAVeryProfound: "15% to 26%",    
};

const Sound = {  
    Title: "Quality of hearing during conversations (with hearing aids)",
    Description: "Ask your patient, do other people's voices sound clear and natural?",
    Groups: ["Not at all",
             "Rarely",
             "Sometimes",
             "Often",
             "Perfectly"]
};

const Effort = {  
    Title: "Ease of hearing during conversations (with hearing aids)",
    Description: "Ask your patient, do you have to put in a lot of effort to hear what has been said in conversation with others?",
    Groups: ["A lot of effort",
        "Often",
        "Sometimes",
        "Rarely",
        "No effort"]
};

const Telephone = {  
    Title: "Having a telephone conversation (with hearing aids)",
    Description: "Ask your patient, can you easily have a conversation on the telephone?",
    Groups: ["Not at all",
             "Rarely",
             "Sometimes",
             "Often",
             "Perfectly"]
};

const Quiet = {  
    Title: "Having a 1:1 conversations in a quiet room (with hearing aids)",
    Description: "Ask your patient, you are talking with one other person in a quiet, carpeted lounge room. Can you follow what the other person says?",
    Groups: ["Not at all",
             "Rarely",
             "Sometimes",
             "Often",
             "Perfectly"]
};

const Searching = {  
    Description: "Searching database for people matching your hearing profile..."
};

const Summary = {
    CurrentStatus: "Your current hearing profile",
    YearsOld: "years old",
    ClearAndNatural: "Clear and natural",
    Effort: "Effort",
    TelephoneConversation: "Telephone conversation",
    OoOConversation: "1:1 conversation",
    NoticeTitle: "Have you noticed that you...",
    noticeItem1: "Are withdrawing from social situations?",
    noticeItem2: "Are tired and stressed from lip reading?",
    noticeItem3: "Have to consider their position in a noisy room to hear better?",
    noticeItem4: "Rely heavily on their partner for hearing support?",
};

const Results = {  
    You:"You",
    After:"After",
    OneOnOneConversation: "One on one conversation",
    Phone: "Phone",
    EffortOfHearing: "Ease of hearing",
    

    RibbonBasedOn: "Based on",
    RibbonYou: "You",
    RibbonText: "<span class='smoke100'>we have searched over</span> <span class='smoke180'>1,500 cochlear implant recipient records,</span> <span class='smoke100 sub-heading2'>12 months after receiving a cochlear implant</span>",

    SpeechTestTitle: "Binaural speech test word score estimates",
    SpeechTestDescription: "Postoperative aided CNC word score (90% prediction interval)",
    SpeechTestBody: "<span class='over-heading1 lavender120'>Over ${}% </span> </br> <span class='smoke180 body1'>of people like you</span> </br> <span class='over-heading1 lavender120 wide-line-height'>improved </br> speech </br> recognition </br></span> <span class='smoke180 body1'>after receiving a cochlear implant</span>",
    ClarityTitle: "Clarity of hearing during conversations",
    ClarityBody: "<span class='smoke180 body1'>People like you </span> </br> <span class='over-heading1 lavender120 wide-line-height'> improved </span> </br> <span class='smoke180 body1'> their </span> </br> <span class='over-heading1 lavender120 wide-line-height'> clarity of hearing </span> </br> <span class='smoke180 body1'> after receiving a cochlear implant</span>",
    OoOTitle: "Have a one on one conversation",
    OoOBody: "<span class='caption1 smoke100'> Over </span> <span class='over-heading1 lavender120'> ${}% </span><br/><span class='caption1 smoke100'> of recipients reported </span><br/> <span class='sub-heading1 lavender120'> improved one on one conversations</span>",
    PhoneTitle: "Have a conversation on the phone",
    PhoneBody: "<span class='caption1 smoke100'> Over </span> <span class='over-heading1 lavender120'> ${}%  </span><br/> <span class='caption1 smoke100'> of recipients reported having </span><br/> <span class='sub-heading1 lavender120'> better phone conversations </span>",
    EaseTitle: "Ease of hearing during conversations",
    EaseBody: "<span class='caption1 smoke100'> Over </span> <span class='over-heading1 lavender120'> ${}%  </span><br/> <span class='caption1 smoke100'> of recipients reported </span><br/> <span class='sub-heading1 lavender120'> easier to hear </span>",

    LegendWordScoreYou: "<span class='smoke100'>Based on the selection, a likely pre-operative word score recognition of</span><span class='smoke180 sub-heading2'> ${}% </span><span class='smoke100'>has been estimated.</span>",
    LegendWordScoreAfter: "<span class='smoke180 sub-heading2'>${}% of recipients improved</span> <span class='smoke100'> to a score of </span><span class='smoke180 sub-heading2'>between ${}% and ${}%</span><span class='smoke100'> 12 months after receiving a cochlear implant as shown above.",
    LegendSsqClarityYou: "<span class='smoke100'>Based on you, a preoperative clarity score of </span><span class='smoke180 sub-heading2'> ${} </span><span class='smoke100'>was selected</span>",
    LegendSsqClarityAfter: "<span class='smoke100'>Results of all recipients are shown, on a scale of 0-10 with 0 being unclear and 10 being clear and natural</span>",

    InfoSmallCardsGreen: "Based on you, a preoperative ${} score of ${} was selected.",
    InfoSmallCardsPurple: "Results display the proportion of cochlear implant recipients that scored themselves as performing better than your selection.",
    Unclear: "Unclear",
    ClearAndNatural: "Clear and natural",
};

const MarketingPanel = {
    Title: "Has your client noticed that they",
    AlertDescription: "Hear alerts and <br/>warning sounds",
    MonitorDescription: "Watch television and <br/>listen to music",
    PhoneDescription: "Have a conversation <br/>on the phone",
    OoOConversationDescription: "Have a one on one <br/>conversation",
};

const MoreInfo = {
    Title: "Find a cochlear implant clinic",
    Description: "Take the next step towards better hearing",
};
